import * as React from 'react';

/**
 * Captures a value and returns the value that was captured during the previous render.
 * Useful to compare props/state against their previous value.
 *
 * @param value The current value.
 * @returns The previous value.
 *
 * @see https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 * @see https://tacklebox.p.kensho.com/usePrevious
 */
export default function usePrevious<T>(value: T): T {
    const ref = React.useRef<T>(value);

    React.useEffect(() => {
        ref.current = value;
    });

    return ref.current;
}
